import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { EditEventLocationComponent } from '../edit-event-location/edit-event-location.component';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
var EventLocationComponent = /** @class */ (function () {
    function EventLocationComponent(_editDescDialog, _toggleService, snackBar, _aviationEventsService) {
        this._editDescDialog = _editDescDialog;
        this._toggleService = _toggleService;
        this.snackBar = snackBar;
        this._aviationEventsService = _aviationEventsService;
        this.dataChangedEvent = new EventEmitter();
        this.editModeSet = false;
    }
    EventLocationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
        if (this.aviationEvent.airportFuelTypes && this.aviationEvent.airportFuelTypes.length > 0) {
            this.airportFuelTypesWithCommas = this.aviationEvent.airportFuelTypes.join(', ');
        }
    };
    EventLocationComponent.prototype.reloadEntity = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._aviationEventsService.getAviationEventById(this.aviationEvent.eventId)];
                    case 1:
                        _a.aviationEvent = _b.sent();
                        this.dataChangedEvent.emit(this.aviationEvent);
                        return [2 /*return*/];
                }
            });
        });
    };
    EventLocationComponent.prototype.openEditLocationDialog = function () {
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '900px';
        dialogConfig.data = { aviationEvent: this.aviationEvent };
        var DIALOG_REF = this._editDescDialog.open(EditEventLocationComponent, dialogConfig);
        this._handleModalClose(DIALOG_REF);
    };
    /**
     * listens for dialog close event. Opens snackbar if necessary
     * @param {MatDialogRef<any>} dialogRef
     * @private
     */
    EventLocationComponent.prototype._handleModalClose = function (dialogRef) {
        var _this = this;
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogRef.afterClosed().subscribe(function (success) {
            if (success === null) {
                return;
            }
            if (success) {
                _this.reloadEntity();
                _this.snackBar.open('Event Venue/Location', 'Updated', {
                    duration: 3000
                });
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return EventLocationComponent;
}());
export { EventLocationComponent };
